import { HttpEventType } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { EquipmentLogbookModel } from 'src/app/models/archive/equipment-logbook.model';
import { EquipmentLogbookPrintModel } from 'src/app/models/archive/equipment-loogbook-print.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { EquipmentLogbookService } from 'src/app/services/archive/equipment-logbook.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { MaintenanceStrategyComponent } from '../maintenance-strategy/maintenance-strategy.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-equipment-logbook',
  templateUrl: './equipment-logbook.component.html',
  styleUrls: ['./equipment-logbook.component.scss'],
  standalone: false,
})
export class EquipmentLogbookComponent implements OnChanges, OnInit {
  @ViewChild('maintenanceStrategy') maintenanceStrategyComponent?: CustomModalComponent | null = null;
  @Input() articleId: number;
  @Input() companyId: number;
  @Input() permissionUpdatable: boolean = true;
  @Input() permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  @Input() userAuthenticated: UserModel = new UserModel();

  componentMaintenanceStrategy = MaintenanceStrategyComponent;
  disabledAttachAdd: boolean = false;
  disabledAttachDownloadDelete: boolean = false;
  equipmentLogbookContract: EquipmentLogbookModel = new EquipmentLogbookModel();
  equipmentLogbookPrintModel: EquipmentLogbookPrintModel = new EquipmentLogbookPrintModel();
  fileName: string = "";
  filePath: SafeUrl = "";
  formEquipmentLogbook: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  inputsForMaintenanceStrategy$ = new BehaviorSubject<any>({
    equipmentLogbookModel: 0,
    swMaintenanceStrategy: false,
    swMaintenanceScheduling: false
  });
  invoiceAttachName: string = "";
  listProviders: any[] = [];
  printLogbookSimple: boolean = true;
  reloadPrintEquipmentLogbook: boolean = false;
  swMaintenanceOrder: boolean = false;
  swMaintenanceScheduling: boolean = false;
  swMaintenanceStrategy: boolean = false;

  constructor(private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private equipmentLogbookService: EquipmentLogbookService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private sanitizer: DomSanitizer,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,) {
  }

  async ngOnInit() {
    this.validateForm(this.equipmentLogbookContract);
    await this.getListProviders();
    this.getGeneralParametersByCompany();
  }

  async ngOnChanges(changes: SimpleChanges) {
    const articleIdChange = changes['articleId'];
    if (articleIdChange && articleIdChange.currentValue !== articleIdChange.previousValue) {
      await this.getEquipmentLogbookByArticleId();
    }
  }

  addAttachInvoice() {
    if (this.equipmentLogbookContract.equipmentLogbookId == 0 || this.equipmentLogbookContract.equipmentLogbookId == null) {
      this.toastHandlerService.showToast(
        'error',
        "Adjuntos solo pueden ser agregados a una hoja de vida existente."
      );
      return;
    } else {
      document.getElementById("files")?.click();
    }
  }

  async chooseFile(event: any) {
    const file = event.target.files[0];
    if (file != null) {
      const formData = new FormData();
      formData.append('files', file);
      try {
        const ok = await firstValueFrom(this.equipmentLogbookService.attachFileToInvoice(this.equipmentLogbookContract.equipmentLogbookId, formData));
        if (ok) this.getEquipmentLogbookByArticleId();
        this.toastHandlerService.showToast(
          'success',
          "El archivo se adjunto exitosamente."
        );
      } catch (error) {
        console.error('Error al adjuntar archivo de la factura.', error);
      }
    }
    // Limpia el campo de archivos
    event.target.value = null;
  }

  async deleteAttachInvoice() {
    if (this.equipmentLogbookContract.equipmentLogbookId != 0) {
      if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar el adjunto?`)) {
        const path: any = this.equipmentLogbookContract.invoiceAttach;
        const file = path.replace(/^.*[\\/]/, '');
        try {
          await firstValueFrom(this.equipmentLogbookService.deleteFileToInvoice(this.equipmentLogbookContract.equipmentLogbookId, file));
          await this.getEquipmentLogbookByArticleId();
          this.toastHandlerService.showToast(
            'success',
            "El adjunto fue eliminado exitosamente."
          );
        } catch (error) {
          console.error('Error al eliminar el adjunto de la factura.', error);
        }
      }
    }
  }

  downloadAttachInvoice() {
    const path: any = this.equipmentLogbookContract.invoiceAttach;
    this.filePath = this.sanitizeImageUrl(path);
    this.fileName = path.replace(/^.*[\\/]/, '');
    if (this.equipmentLogbookContract.equipmentLogbookId != 0) {
      this.equipmentLogbookService.downloadFileToInvoice(this.equipmentLogbookContract.equipmentLogbookId, this.fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = this.fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  finishPrintEquipmentLogbook(finishPrint: boolean) {
    if (finishPrint) window.print();
  }

  async getEquipmentLogbookByArticleId() {
    if (this.permissionUpdatable) {
      if (this.articleId != 0 && this.articleId != null) {
        const response = await firstValueFrom(this.equipmentLogbookService.getEquipmentLogbookByArticleIdAsync(this.articleId));
        if (response.equipmentLogbookId == 0) {
          this.equipmentLogbookContract = new EquipmentLogbookModel();
          this.equipmentLogbookContract.articleId = this.articleId;
          this.validateForm(this.equipmentLogbookContract);
        } else {
          this.equipmentLogbookContract = response;
          this.validateForm(this.equipmentLogbookContract);
        }
      } else {
        this.equipmentLogbookContract = new EquipmentLogbookModel();
        this.equipmentLogbookContract.articleId = this.articleId;
        this.validateForm(this.equipmentLogbookContract);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        "El usuario no tiene permisos para crear hoja de vida de artículos. Comuníquese con el administrador del sistema."
      );
    }
  }

  getFileName(path: string): string {
    if (!path) return '';
    return path.split(/[/\\]/).pop() ?? path;
  }

  async getFormatByCompanyAndCode(formatCode: number) {
    try {
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, formatCode));
    } catch (error) {
      console.error('Error al buscar el formato.', error);
    }
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(async response => {
        this.swMaintenanceStrategy = response.some(x => x.name === GeneralParameters.maintenanceStrategy);
        this.swMaintenanceOrder = response.some(x => x.name === GeneralParameters.maintenanceOrder);
        this.swMaintenanceScheduling = response.some(x => x.name === GeneralParameters.maintenanceScheduling);
      });
      resolve(true);
    });
  }

  async getListProviders() {
    try {
      this.listProviders = await firstValueFrom(this.equipmentLogbookService.getAllProvidersForSelectAsync());
    } catch (error) {
      console.error('Error al buscar los proveedores.', error);
    }
  }

  async printLogbook(simple: boolean) {
    this.printLogbookSimple = simple;
    const formatCode = simple ? FormatsEnums.simpleEquipmentLogbook : FormatsEnums.valuedEquipmentLogbook;
    this.toastHandlerService.clearAllToasts();

    if (this.equipmentLogbookContract.equipmentLogbookId == 0 || this.equipmentLogbookContract.equipmentLogbookId == null) {
      this.toastHandlerService.showToast(
        'warning',
        "Debe crear una Hoja de Vida."
      );
      return;
    }

    if (this.userAuthenticated.profileUser.code != ProfileUserEnums.administrador && !this.permissionsUser.some(x => x.code === OptionWindow.imprimir)) {
      this.toastHandlerService.showToast(
        'error',
        "El usuario no tiene permisos para imprimir hojas de vida de equipos. Comuníquese con el administrador del sistema."
      );
      return;
    }

    try {
      await this.getFormatByCompanyAndCode(formatCode);
      this.equipmentLogbookPrintModel = await firstValueFrom(
        this.equipmentLogbookService.getEquipmentLogbookByKeysByPrintAsync(this.companyId, this.equipmentLogbookContract.consecutive, this.articleId)
      );
      this.reloadPrintEquipmentLogbook = !this.reloadPrintEquipmentLogbook;
    } catch (error) {
      console.error('Error al buscar la hoja de vida para imprimir.', error);
    }
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }

  async send() {
    if (this.formEquipmentLogbook.valid) {
      const equipmentLogbookmodel = this.formEquipmentLogbook.value as EquipmentLogbookModel;
      equipmentLogbookmodel.articleId = this.equipmentLogbookContract.articleId;
      if (this.equipmentLogbookContract.equipmentLogbookId == 0) {
        this.equipmentLogbookContract = await firstValueFrom(this.equipmentLogbookService.createEquipmentLogbook(equipmentLogbookmodel));
        this.validateForm(this.equipmentLogbookContract);
        this.toastHandlerService.showToast(
          'success',
          "La hoja de vida se creo exitosamente"
        );
      } else {
        this.equipmentLogbookContract.providerId = equipmentLogbookmodel.providerId;
        this.equipmentLogbookContract.invoiceNumber = equipmentLogbookmodel.invoiceNumber;
        this.equipmentLogbookContract.purchaseDate = equipmentLogbookmodel.purchaseDate;
        this.equipmentLogbookContract.purchaseValue = equipmentLogbookmodel.purchaseValue;
        this.equipmentLogbookContract.trademark = equipmentLogbookmodel.trademark;
        this.equipmentLogbookContract.commercialName = equipmentLogbookmodel.commercialName;
        this.equipmentLogbookContract.reference = equipmentLogbookmodel.reference;
        this.equipmentLogbookContract.serie = equipmentLogbookmodel.serie;
        this.equipmentLogbookContract.yearManufacture = equipmentLogbookmodel.yearManufacture;
        this.equipmentLogbookContract.warrantyInitialDate = equipmentLogbookmodel.warrantyInitialDate;
        this.equipmentLogbookContract.warrantyFinalDate = equipmentLogbookmodel.warrantyFinalDate;
        this.equipmentLogbookContract.equipmentType = equipmentLogbookmodel.equipmentType;
        this.equipmentLogbookContract.voltage = equipmentLogbookmodel.voltage;
        this.equipmentLogbookContract.power = equipmentLogbookmodel.power;
        this.equipmentLogbookContract.amperage = equipmentLogbookmodel.amperage;
        this.equipmentLogbookContract.capacity = equipmentLogbookmodel.capacity;
        this.equipmentLogbookContract.engineType = equipmentLogbookmodel.engineType;
        this.equipmentLogbookContract.engineCode = equipmentLogbookmodel.engineCode;
        this.equipmentLogbookContract.trademarkEngine = equipmentLogbookmodel.trademarkEngine;
        this.equipmentLogbookContract.referenceEngine = equipmentLogbookmodel.referenceEngine;
        this.equipmentLogbookContract.serieEngine = equipmentLogbookmodel.serieEngine;
        this.equipmentLogbookContract.observation = equipmentLogbookmodel.observation;
        this.equipmentLogbookContract = await firstValueFrom(this.equipmentLogbookService.updateArticle(this.equipmentLogbookContract));
        this.validateForm(this.equipmentLogbookContract);
        this.toastHandlerService.showToast(
          'success',
          'La hoja de vida se actualizo exitosamente'
        );
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      providerId: 'El campo Proveedor es obligatorio.',
      purchaseDate: 'El campo Fecha Compra es obligatorio.',
      purchaseValue: 'El campo Valor Compra es obligatorio.',
      commercialName: 'El campo Denominación Ccial es obligatorio.',
      reference: 'El campo Referencia es obligatorio.',
      serie: 'El campo Serie es obligatorio.',
    };
    Object.keys(controlMessages).forEach(control => {
      if (this.formEquipmentLogbook.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención');
      }
    });
  }

  openMaintenanceStrategy() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        "El usuario no tiene permisos para crear estrategia mtto. Comuníquese con el administrador del sistema."
      );
      return;
    }

    if (this.equipmentLogbookContract.equipmentLogbookId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        "Debe crear la hoja de vida."
      );
      return;
    }

    this.inputsForMaintenanceStrategy$.next({
      equipmentLogbookModel: this.equipmentLogbookContract,
      swMaintenanceStrategy: this.swMaintenanceStrategy,
      swMaintenanceScheduling: this.swMaintenanceScheduling
    });
    this.maintenanceStrategyComponent?.show();
  }

  validateForm(equipmentLogbook: EquipmentLogbookModel) {
    this.formEquipmentLogbook = this.formBuilder.group({
      consecutive: [equipmentLogbook.consecutive, []],
      providerId: [equipmentLogbook.providerId, [Validators.required]],
      invoiceNumber: [equipmentLogbook.invoiceNumber, []],
      purchaseDate: [equipmentLogbook.purchaseDate ? this.dateConverterService.convertUtcToLocalDate(equipmentLogbook.purchaseDate)
        : null, [Validators.required]],
      purchaseValue: [equipmentLogbook.purchaseValue, [Validators.required, Validators.max(9999999999.99), Validators.min(0)]],
      trademark: [equipmentLogbook.trademark, []],
      commercialName: [equipmentLogbook.commercialName, [Validators.required]],
      reference: [equipmentLogbook.reference, [Validators.required]],
      serie: [equipmentLogbook.serie, [Validators.required]],
      yearManufacture: [equipmentLogbook.yearManufacture, []],
      warrantyInitialDate: [equipmentLogbook.warrantyInitialDate ?
        this.dateConverterService.convertUtcToLocalDate(equipmentLogbook.warrantyInitialDate) : null, []],
      warrantyFinalDate: [equipmentLogbook.warrantyFinalDate ?
        this.dateConverterService.convertUtcToLocalDate(equipmentLogbook.warrantyFinalDate) : null, []],
      equipmentType: [equipmentLogbook.equipmentType, []],
      voltage: [equipmentLogbook.voltage, []],
      power: [equipmentLogbook.power, []],
      amperage: [equipmentLogbook.amperage, []],
      capacity: [equipmentLogbook.capacity, []],
      engineType: [equipmentLogbook.engineType, []],
      engineCode: [equipmentLogbook.engineCode, []],
      trademarkEngine: [equipmentLogbook.trademarkEngine, []],
      referenceEngine: [equipmentLogbook.referenceEngine, []],
      serieEngine: [equipmentLogbook.serieEngine, []],
      observation: [equipmentLogbook.observation, []]
    });
    setTimeout(() => this.formEquipmentLogbook.controls["consecutive"].disable(), 100);
    if (equipmentLogbook.invoiceAttach) {
      this.invoiceAttachName = this.getFileName(equipmentLogbook.invoiceAttach);
      this.disabledAttachAdd = true;
      this.disabledAttachDownloadDelete = false;
    } else {
      this.invoiceAttachName = "";
      this.disabledAttachAdd = false;
      this.disabledAttachDownloadDelete = true;
    }
  }
}
